import { render } from "./CheckoutOrderOverview.vue?vue&type=template&id=c1fd0c72"
import script from "./CheckoutOrderOverview.vue?vue&type=script&lang=js"
export * from "./CheckoutOrderOverview.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__